import { FC } from 'react';

import useStartYourApplicationEditableAsset from '@core/hooks/useStartYourApplicationEditableAsset';

import { Cta } from '../../hooks/useGetApplicationCtaData';
import styles from './LeadSubmittedCta.module.css';

type Props = {
  cta: Cta;
  schoolId?: string;
};

const LeadSubmittedCta: FC<Props> = ({ cta, schoolId }) => {
  const { CtaLabelEA } = useStartYourApplicationEditableAsset(schoolId?.toString() || '');
  return cta?.label && cta?.url ? (
    <div className={styles.ctaButton}>
      <CtaLabelEA>{cta.label}</CtaLabelEA>
    </div>
  ) : (
    <div className={styles.nextStepsButton}>
      <CtaLabelEA>Next Steps</CtaLabelEA>
    </div>
  );
};
export default LeadSubmittedCta;
